import getFromCdn from '@anm/helpers/getFromCdn';
import styled from 'styled-components';

import Modal from '../modals/Modal';

export const ModalWrapper = styled(Modal)`
  padding: 0;
  border-radius: 10px;
  background: url(${getFromCdn('images/data/affiliate-popup-bg.svg')}) no-repeat 0 0 transparent;
  background-size: cover;
  box-shadow: 4px 4px 80px rgba(0, 0, 0, 0.5);
  max-height: 90vh;
  &:after {
    display: none;
  }
`;
